import {
  AthleteStatLeaderboard,
  LeaderboardContextType,
  LeaderboardLinks
} from '@maxpreps/apiserviceclients/apiModels';
import { FetchResponse } from '@maxpreps/network/src/fetchResponse';
import {
  GetAsync,
  ghostApiSimpleWrapper
} from '@maxpreps/network/src/simpleWrapper';

// Schedule
export const getFeaturedGameBoxGateway = async (teamId, sportSeasonId) =>
  ghostApiSimpleWrapper(
    `/gatewayweb/react/next-contest-box/v1?teamId=${teamId}&sportSeasonId=${sportSeasonId}`
  );

// Concordia

// GetTopTeamRankingsStateAsync
export const getStateSportRankingsGateway = async (
  stateCode,
  allseasonid,
  count
) => {
  const options = {
    queryParams: {
      allseasonid,
      stateCode,
      count
    }
  };
  return ghostApiSimpleWrapper(
    `/gatewayweb/react/team-rankings-top-state/v1`,
    options
  );
};

// GetTopTeamRankingsSectionAsync
export const getSectionSportRankingsGateway = async (
  sectionId,
  allseasonid,
  count
) => {
  const options = {
    queryParams: {
      allseasonid,
      sectionId,
      count
    }
  };
  return ghostApiSimpleWrapper(
    `/gatewayweb/react/team-rankings-top-section/v1`,
    options
  );
};

// GetTopTeamRankingsNationalAsync
export const getNationalRankingsGateway = async (allseasonid, count) => {
  const options = {
    queryParams: {
      allseasonid,

      count
    }
  };
  return ghostApiSimpleWrapper(
    `/gatewayweb/react/team-rankings-top-national/v1`,
    options
  );
};

// JSON LD

// GetTeamJsonLdAsync
export const getTeamLinkedDataGateway = async (
  schoolId,
  sportSeasonId,
  includeRoster = false,
  includeSchedule = false,
  options: any = {}
) => {
  options.queryParams = {
    ...options.queryParams,
    teamid: schoolId,
    sportSeasonId
  };
  if (includeRoster) {
    options.queryParams = { ...options.queryParams, includeRoster: true };
  }
  if (includeSchedule) {
    options.queryParams = { ...options.queryParams, includeSchedule: true };
  }
  return ghostApiSimpleWrapper(`/gatewayweb/react/jsonld/team/v1`, options);
};

// Team Info

// GetTeamRankingsAsync
export const getTeamRankingsGateway = async (
  schoolId,
  sportSeasonId,
  options: any = {}
) => {
  options.queryParams = {
    ...options.queryParams,
    teamId: schoolId,
    sportSeasonId
  };

  const [data, error, json, response] = await ghostApiSimpleWrapper(
    '/gatewayweb/react/team-rankings-context/v1',
    options
  );

  // we are appending some notes here
  // (Ryan) I'd argue that this belongs in the api but for whatever reason we are injecting them in all react usagaes of this endpoint and not in other FE apps
  // We are intentionally NOT putting it on the json object - that is intended to be clean and original
  const NOTES = [
    'Learn about the rankings|https://www.maxpreps.com/news/X4MCEfnBEeC-rAAmVebEWg/how-the-maxpreps-computer-rankings-work.htm'
  ];

  if (data) {
    (data as any).notes = ((data as any).notes ?? []).concat(NOTES);
  }

  return [data, error, json, response];
};

export const getSharedStatsLinks = async (teamId, ssid) =>
  ghostApiSimpleWrapper(
    `/gatewayweb/react/stat-shared-links/v1?teamid=${teamId}&sportseasonid=${ssid}`
  );

export const getTeamSchedule = async (schoolId, sportSeasonId) =>
  ghostApiSimpleWrapper(
    `/gatewayweb/react/schedule-calculated/v1?teamId=${schoolId}&sportSeasonid=${sportSeasonId}`
  );

// The functions below this comment have been modified from the auto-generated versions.
// They need to be adjusted in the service clients for various reasons.

// Original does not handle optional query params
export const GetAthleteStatLeaderboardAsync = async (
  sportSeasonId: string,
  contextId?: string,
  group?: string,
  subGroup?: string,
  statName?: string,
  positionCategory?: string,
  classYear?: number | string,
  teamSize?: number | string,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<AthleteStatLeaderboard>> => {
  const queryParams: any = {
    sportSeasonId
  };
  if (contextId) queryParams.contextId = contextId;
  if (group) queryParams.group = group;
  if (subGroup) queryParams.subGroup = subGroup;
  if (statName) queryParams.statName = statName;
  if (positionCategory) queryParams.positionCategory = positionCategory;
  if (classYear) queryParams.classYear = classYear;
  if (teamSize) queryParams.teamSize = teamSize;

  const qs = new URLSearchParams(queryParams).toString();

  return GetAsync<AthleteStatLeaderboard>(
    `/gatewayweb/react/athlete-stat-leaderboard/v1?${qs}`,
    token,
    headers
  );
};

// Original does not handle missing contextId
export const GetSharedLeaderboardLinksAsync = async (
  allSeasonId: string,
  contextId: string,
  contextType: LeaderboardContextType,
  token: string = '',
  headers: object | null = {}
): Promise<FetchResponse<LeaderboardLinks>> => {
  const qs =
    contextType === LeaderboardContextType.National
      ? ''
      : `&contextId=${contextId}`;
  return GetAsync<LeaderboardLinks>(
    `/gatewayweb/react/leaderboard-shared-links/v1?allSeasonId=${allSeasonId}&contextType=${contextType}${qs}`,
    token,
    headers
  );
};

// Original uses allSeasonId as query param instead of sportseasonid
export const GetTeamContextAsync = async (teamId, ssid) =>
  ghostApiSimpleWrapper(
    `/gatewayweb/react/team-context/v1?teamid=${teamId}&sportseasonid=${ssid}`
  );
